import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { IPropertyType } from '../models';

const baseUrl = '/api/Admin/PropertyType';

export const PropertyTypesAPI = {
  async getAll(): Promise<IPropertyType[]> {
    try {
      const response: AxiosResponse<IPropertyType[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async upsert(upsertData: IPropertyType[]): Promise<IPropertyType[]> {
    try {
      const response: AxiosResponse<IPropertyType[]> = await authFetch.post(baseUrl, upsertData);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async delete(PropertySubTypeId: number): Promise<void> {
    try {
      await authFetch.delete(`${baseUrl}/${PropertySubTypeId}`);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
